import Cookies from 'js-cookie'
import { isEmpty, isNil } from 'lodash'
import { flow, split, map, last, filter, trim, includes } from 'lodash/fp'
import { User } from '../types/models'

export const isValidEmail = (email: string) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailRegex.test(email)
}

export const getHeader = () => {
  return {
    /**
     * NOTE: 도메인별 쿠키 문제가 생길 시, odk-web의 utils.js/getCSRF 함수를 참고할 것
     * https://github.com/ondemandkorea/odk-web/pull/1063
     * https://ondemandkorea.atlassian.net/browse/KW-4161
     */
    'X-CSRFToken': getLatestCookie('csrf_token'),
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  }
}

export const serializePayload = payload =>
  Object.keys(payload)
    .map(key => key + '=' + encodeURIComponent(payload[key]))
    .join('&')

export const getLatestCookie = (name: string) => {
  if (isEmpty(document?.cookie)) {
    return
  }
  const latestCookie = flow(
    split(';'),
    map(trim),
    filter(includes(name)),
    last,
    split('='),
    last,
    decodeURIComponent
  )(document.cookie)

  return latestCookie
}

export const setCookie = (cookieKey: string, value: string, expiredDate?: number) => {
  const DEFAULT_EXPIRED_DATE = 3650
  Cookies.set(cookieKey, value, { path: '/', expires: expiredDate ?? DEFAULT_EXPIRED_DATE })
}

// NOTE: odk-web에서 guest user의 id는 2라고 한다.
const GUEST_USER_ID = '2'

export const isGuestUser = (user: User | null) => isNil(user) || user?.id === GUEST_USER_ID
